<template>
  <AdminLayout>
    <template #content>
      <div class="d-flex justify-content-between align-items-start gap-3 mb-3">
        <div>
          <h1 class="h4 mb-1">Nouveau transfert de stock</h1>
          <small class="text-muted">Préparez les produits à expédier vers un autre site.</small>
        </div>

        <button
          type="button"
          class="btn btn-outline-secondary btn-sm btn-icon-label"
          title="Retour à la liste"
          @click="$router.push({ name: 'StockTransfers' })"
        >
          <i class="fa fa-arrow-left"></i>
          <span class="btn-label ms-1">Retour à la liste</span>
        </button>
      </div>

      <div v-if="errorMessage" class="alert alert-danger py-2">
        {{ errorMessage }}
      </div>

      <div class="card border-0 shadow-sm">
        <div class="card-body">
          <StockTransferForm
            mode="create"
            :submitting="isSubmitting"
            @save="createTransfer"
            @cancel="$router.push({ name: 'StockTransfers' })"
          />
        </div>
      </div>
    </template>
  </AdminLayout>
</template>

<script>
import StockTransferForm from './StockTransferForm.vue';

export default {
  name: 'StockTransferCreateView',
  components: {
    StockTransferForm,
  },
  data() {
    return {
      isSubmitting: false,
      errorMessage: '',
    };
  },
  methods: {
    async createTransfer(payload) {
      this.isSubmitting = true;
      this.errorMessage = '';

      try {
        const response = await this.$api.post('/stock-transfers', payload);
        const transfer = response.data.data;
        this.$router.push({ name: 'StockTransferShow', params: { id: transfer.id } });
      } catch (error) {
        this.errorMessage = this.extractErrorMessage(error, 'Impossible de créer le transfert.');
      } finally {
        this.isSubmitting = false;
      }
    },
    extractErrorMessage(error, fallback) {
      if (error?.response?.data?.errors) {
        return Object.values(error.response.data.errors).flat().join(' ');
      }

      return fallback;
    },
  },
};
</script>
